<template>
  <div class="preview-part">
    <template v-if="isCodePartUnSelectable">
      <p class="code-warn-msg">
        <span class="code-warn-icon">
          <i class="fas fa-exclamation-circle"></i>
        </span>
        <span class="code-warn-text">
          コードパーツを正しく設定してください
        </span>
      </p>
    </template>
    <!-- SNSアイコンパーツ -->
    <div
      v-if="part.type === 'SnsIcon'"
      v-html="generateHTML({
        part: this.part,
        partsContainerType: partsContainerType,
        layoutType: partsContainerLayoutType,
        shareText: partsContainerShareText
      })"
      @click.prevent
    />
    <!-- 画像カード内のパーツ -->
    <template v-else-if="partsContainerType === 'ImageCard'">
      <div
        v-if="!isShowDropZonePart"
        v-html="generateHTML({
          part: this.part,
          partsContainerType: partsContainerType,
          layoutType: partsContainerLayoutType
        })"
        :style="imageCardPartWidth"
        @click.prevent
        :key="part.id"
      />
      <!-- 画像ドロップエリア -->
      <drop-zone-part
        v-else
        :key="part.id"
        :body="part.body"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partId="part.id"
        :style="[dropZoneStyle, imageCardPartWidth]"
        :partWidth="partWidth.width"
        :horizontalDisplayRatio="horizontalDisplayRatio"
        @updateSectionHeight="updateSectionHeight"
      />
    </template>
    <table v-else :style="partWidthStyle" style="width: 100%;">
      <tbody>
        <tr>
          <td :ref="'parts' + part.id">
            <div
              v-if="!isShowDropZonePart"
              v-html="generateHTML({
                part: this.part,
                partsContainerType: partsContainerType,
                layoutType: partsContainerLayoutType
              })"
              @click.prevent
              :key="part.id"
            />
            <!-- 画像ドロップエリア -->
            <drop-zone-part
              v-else
              :key="part.id"
              :body="part.body"
              :sectionId="sectionId"
              :partsContainerId="partsContainerId"
              :partId="part.id"
              :style="dropZoneStyle"
              :partWidth="partWidth.width"
              :horizontalDisplayRatio="horizontalDisplayRatio"
              @updateSectionHeight="updateSectionHeight"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DropZonePart from '@/components/Content/Preview/PreviewPart/DropZonePart'
import { generate } from '@/utils/GeneratePartHTML'
import ImagePartBase from '@/components/Content/ImagePartBase'

export default {
  name: 'PreviewPart',
  props: [
    'part',
    'partsContainerId',
    'sectionId',
    'partWidth',
    'draggingSectionPadding',
    'columnCount',
    'partsContainerType',
    'partsContainerLayoutType',
    'partsContainerStyles',
    'partsContainerShareText',
    'horizontalDisplayRatio',
  ],
  mixins: [
    ImagePartBase,
  ],
  components: {
    DropZonePart,
  },
  methods: {
    generateHTML: generate,
    updateSectionHeight () {
      this.$emit('updateSectionHeight')
    },
    setIsCodePartUnSelectable () {
      this.isCodePartUnSelectable = (!this.$refs['parts' + this.part.id].clientHeight || !this.$refs['parts' + this.part.id].clientWidth)
    }
  },
  data () {
    return {
      isCodePartUnSelectable: false
    }
  },
  computed: {
    // 表示しているカラーピッカー
    currentColorPicker () {
      return this.$store.getters.getStatusColorPicker
    },
    partStyle () {
      return this.part.styles
    },
    partAttr () {
      return this.part.attrs
    },
    isShowDropZonePart () {
      return this.part.type === 'Image' && !(this.part.attrs['data-key'])
    },
    // 画像ドロップエリアのスタイル
    dropZoneStyle () {
      // 画像系パーツ以外 または 画像カードパーツコンテナの場合、何もしない
      if (this.part.type !== 'Image' || this.partsContainerType === 'ImageCard') return
      return {
        'padding-top': this.part.styles['padding-top'] || null,
        'padding-right': this.part.styles['padding-right'] || null,
        'padding-bottom': this.part.styles['padding-bottom'] || null,
        'padding-left': this.part.styles['padding-left'] || null,
      }
    },
    partWidthStyle () {
      if (this.part.type === 'Spacer') {
        // スペーサー：スペーサーの幅を返す
        return { 'width': this.part.attrs['width'] }
      } else {
        return { 'width': this.partWidth.width }
      }
    },
    // 画像カードパーツの幅
    // TODO: 同じ処理がHTMLプレビューにあるので、タイミングを見て共通化したい
    imageCardPartWidth () {
      // 画像カードパーツ以外は、何もしない
      if (this.partsContainerType !== 'ImageCard') return null
      const partWidth = { ...this.partWidth }
      // パーツコンテナの罫線幅を取得
      let borderWidth = 0
      if (this.partsContainerStyles['border']) {
        // スタイルは border 1px solid の形になっているので、インデックス1番が線の太さ
        const borderStyles = this.partsContainerStyles['border'].split(' ')
        // 縦レイアウトの時は左右2つの罫線、横レイアウトの時は左または右の1つの罫線で判定
        borderWidth = this.partsContainerLayoutType === 'vertical' ? Number(borderStyles[1].replace(/px/g, '')) * 2 : Number(borderStyles[1].replace(/px/g, ''))
      }
      // パーツの幅を決定
      partWidth.width = (Number(partWidth.width.replace('px', '')) - borderWidth) + 'px'

      return partWidth
    },
  },
  mounted () {
    if (this.part.type === 'Code') {
      this.setIsCodePartUnSelectable()
      this.$emit('updateEditingColor', this.isCodePartUnSelectable)
    }
  },
  watch: {
    'part.body' (value) {
      // パーツの内容が変更された場合、セクションの高さを更新
      this.$emit('updateSectionHeight')

      // コードパーツで選択できないサイズにされた場合、文言を表示する
      if (this.part.type === 'Code') {
        this.$nextTick(() => {
          this.setIsCodePartUnSelectable()
          this.$emit('updateEditingColor', this.isCodePartUnSelectable)
        })
      }
      return value
    },
    partStyle: {
      deep: true,
      handler: function () {
        // パーツのスタイルが変更された場合、セクションの高さを更新
        this.$emit('updateSectionHeight')
      }
    },
    partAttr: {
      deep: true,
      handler: function () {
        // パーツの属性が変更された場合、セクションの高さを更新
        this.$emit('updateSectionHeight')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.preview-part {
  .code-warn-icon {
    margin-right: 5px;
    font-size: 18px !important;
  }
  .code-warn-text {
    font-size: 16px !important;
  }
  .code-warn-msg {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    color: #dd6a59 !important;
    height: 34px !important;
    background-color: #f7d9d5 !important;
    text-align: center !important;
  }
}
</style>
